import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import SearchWorkplaceMember from './SearchWorkplaceMember';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';

loadDOMComponent({
	selector: 'react-search-workplace-member',
	callback: ({ container, context }) => {
		const linkSelect = container.getAttribute('linkSelect') || null;
		const gqlParams = JSON.parse(container.getAttribute('gqlParams') || '{}');
		const hideFavoriteButton =
			container.getAttribute('hideFavoriteButton') !== null;
		const hideEmptySearch = container.getAttribute('hideEmptySearch') !== null;
		const workplaceFromElement = container.getAttribute('workplaceFromElement');
		const patientId = container.getAttribute('patientId');

		// selectLink
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<SearchWorkplaceMember
						linkSelect={linkSelect}
						gqlParams={gqlParams}
						hideFavoriteButton={hideFavoriteButton}
						hideEmptySearch={hideEmptySearch}
						workplaceFromElement={workplaceFromElement}
						patientId={patientId}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
